<script setup>
import { ref, toRaw } from "vue";
const year = ref(new Date().getFullYear());
import routes from "@/router/routes.js";
import { useRouter } from "vue-router";
const router = useRouter();
let curRouter = ref(toRaw(router).currentRoute.value.fullPath);

const pageRoutes = ref(routes.filter(item=>item.path !== '/'))
const goPage = (menu, isShow) => {
  router.push(menu);
  curRouter.value = menu.path;
  if (isShow) showSreen.value = false;
};
</script>

<template>
  <div class="Footer-box">
    <!-- <div class="foot_part1">
      <el-row :gutter="0" class="container">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
          <div class="mune">
            <div
              class="mune-item"
              v-for="menu in pageRoutes"
              @click="goPage(menu, true)"
            >
              <div>
                <div class="title2">{{ menu.name }}</div></div>
            </div>
          </div>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          
        </el-col>
      </el-row>
    </div> -->
    <el-row :gutter="0" class="record">
      <el-col :xs="0" :sm="0" :md="0" :lg="24" :xl="24">
        Copyright © {{ year }} 版权所有 北京清软创新科技股份有限公司
        京ICP备05077426号-1
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="0" :xl="0">
        Copyright © {{ year }} 版权所有 北京清软创新科技股份有限公司
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="0" :xl="0">
        京ICP备05077426号-1
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.Footer-box {
  text-align: center;
}
.Footer-box .record {
  // height: 2.5rem;
  background: #212d56;
  color: #fff;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 150%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vw 0;
  box-sizing: border-box;
}
.foot_part1 {
  padding:1vw 0;
  text-align: center;  
  background-color: #eef0f5;
  // position: relative;
  .mune {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
}
@media screen and (min-width: 1280.01px) {
  .page-footer {
    --columnWidth: 11.88rem;
    --lastColumnWidth: 11rem;
    --maxTitleWidth: 6.99rem;
  }
}
@media screen and (min-width: 1080px) {
  .page-footer {
    --columnWidth: 14.01rem;
    --lastColumnWidth: 11rem;
    --maxTitleWidth: 6.99rem;
  }
}
.page-footer {
  width: 100%;
  background: #004d6d;
  --columnWidth: 11.875rem;
  --lastColumnWidth: 11rem;
  --maxTitleWidth: 7rem;
}
</style>
